import React from 'react'
import { DatePicker } from '../Inputs/DatePicker'

type Props = {
  startDate: Date | undefined
  endDate: Date | undefined
  onStartDateChange: (date: Date | undefined) => void
  onEndDateChange: (date: Date | undefined) => void
  disabled?: boolean
}

export const DateRangePicker: React.FC<Props> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled = false
}) => {
  return (
    <div className="date-range-container">
      <DatePicker
        label="See sources after"
        name="startDate"
        selected={startDate}
        onChange={(date) => onStartDateChange(date ? date[0] : undefined)}
        maxDate={endDate ?? new Date()}
        disabled={disabled}
      />

      <DatePicker
        label="See sources before"
        name="endDate"
        selected={endDate}
        onChange={(date) => onEndDateChange(date ? date[0] : undefined)}
        minDate={startDate}
        maxDate={new Date()}
        disabled={disabled}
      />
    </div>
  )
}
